export enum InventoryTransaction {
  ADJUSTMENT_ENTRY = 'ADJUSTMENT ENTRY',
  PURCHASE_ORDER = 'PURCHASE ORDER',
  RECEIVING_REPORT = 'RECEIVING REPORT',
  DEFECTIVE_REPORT = 'DEFECTIVE REPORT',
  SALES_ORDER = 'SALES ORDER',
  TRANSFER_ORDER = 'TRANSFER ORDER',
  PICKLIST = 'PICKLIST',
  IMPORT_QUANTITIES = 'IMPORT QUANTITIES',
  PENDING_SKU_RECOUNT = 'PENDING SKU RECOUNT',
  PENDING_KIT_RECOUNT = 'PENDING KIT RECOUNT',
  MANUAL = 'MANUAL',
  PICK_MANUAL = 'PICK-MANUAL',
  UPDATE_MANUAL_ROLLBACK = 'UPDATE-MANUAL [ROLLBACK]',
  ADJUSTMENT_ENTRY_RETURN = 'ADJUSTMENT ENTRY - RETURN',
  SKU_LOCATION_TRANSFER = 'SKU LOCATION TRANSFER',
  PICK_AUTO = 'PICK-AUTO',
  FULFILLMENT_ORDER = 'FULFILLMENT ORDER',
}

export const CInventoryTransactions = [
  {
    value: 'ADJUSTMENT ENTRY',
    isClickableRemarks: false,
    formattableDetails: true,
  },
  {
    value: 'PURCHASE ORDER',
    isClickableRemarks: true,
    formattableDetails: true,
  },
  {
    value: 'RECEIVING REPORT',
    isClickableRemarks: false,
    formattableDetails: true,
  },
  {
    value: 'DEFECTIVE REPORT',
    isClickableRemarks: false,
    formattableDetails: true,
  },
  {
    value: 'SALES ORDER',
    isClickableRemarks: true,
    formattableDetails: true,
  },
  {
    value: 'PICKLIST',
    isClickableRemarks: true,
    formattableDetails: true,
  },
  {
    value: 'IMPORT QUANTITIES',
    isClickableRemarks: false,
    formattableDetails: true,
  },
  {
    value: 'PENDING SKU RECOUNT',
    isClickableRemarks: false,
    formattableDetails: true,
  },
  {
    value: 'PENDING KIT RECOUNT',
    isClickableRemarks: false,
    formattableDetails: true,
  },
  {
    value: 'MANUAL',
    isClickableRemarks: true,
    formattableDetails: false,
  },
  {
    value: 'PICK-MANUAL',
    isClickableRemarks: true,
    formattableDetails: false,
  },
  {
    value: 'UPDATE-MANUAL [ROLLBACK]',
    isClickableRemarks: false,
    formattableDetails: true,
  },
  {
    value: 'ADJUSTMENT ENTRY - RETURN',
    isClickableRemarks: false,
    formattableDetails: false,
  },
  {
    value: 'SKU LOCATION TRANSFER',
    isClickableRemarks: true,
    formattableDetails: true,
  },
  {
    value: 'PICK-AUTO',
    isClickableRemarks: true,
    formattableDetails: true,
  },
  {
    value: 'TRANSFER ORDER',
    isClickableRemarks: true,
    formattableDetails: true,
  },
  {
    value: 'FULFILLMENT ORDER',
    isClickableRemarks: true,
    formattableDetails: true,
  },
];

export const InventoryTransactionLookUp = [
  {
    label: 'ADJUSTMENT ENTRY',
    value: 'adjustment_entry',
  },
  {
    label: 'DEFECTIVE REPORT',
    value: 'defective_report',
  },
  {
    label: 'PICK-MANUAL',
    value: 'pick_manual',
  },
  {
    label: 'PICK-AUTO',
    value: 'pick_auto',
  },
  {
    label: 'PICK-AUTO [SHIPPED]',
    value: 'pick_auto_shipped',
  },
  {
    label: 'PURCHASE ORDER',
    value: 'purchase_order',
  },
  {
    label: 'RECEIVING REPORT',
    value: 'receiving_report',
  },
  {
    label: 'SKU LOCATION TRANSFER',
    value: 'sku_location_transfer',
  },
  {
    label: 'PENDING SKU RECOUNT',
    value: 'pending_sku_recount',
  },
  {
    label: 'PENDING KIT RECOUNT',
    value: 'pending_kit_recount',
  },
  {
    label: 'IMPORT QUANTITIES',
    value: 'import_quantities',
  },
  {
    label: 'ADJUSTMENT ENTRY - RETURN',
    value: 'adjustment_entry_return',
  },
  {
    label: 'PICKLIST',
    value: 'picklist',
  },
  {
    label: 'SALES ORDER',
    value: 'sales_order',
  },
  {
    label: 'TRANSFER ORDER',
    value: 'transfer_order',
  },
];
